import { GetNobatPrefrences } from 'utils/GetNobatPrefrences';

export const SelectType = () => {
  const prefrences = GetNobatPrefrences();

  const noeEntekhab = prefrences
    ? prefrences?.filter(
        (prefrence) =>
          prefrence.Key === 'webAppnoeEntekhabeNobatPatient'
      )[0]?.Value
    : null;

  return noeEntekhab;
};
